import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles, Divider } from '@material-ui/core';
import { NoDataItem } from '~/modules/common/components';
import TaskEstimateRow from './TaskEstimateRow';

const useDividerStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0, 0, 1)
  }
}));

const useRowStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(0, 2)
  }
}));

export const TaskResourceEstimatesContent = ({ loading = false }) => {
  const dividerClasses = useDividerStyles();
  const rowClasses = useRowStyles();

  return (
    <div className={rowClasses.container}>
      <Divider className={dividerClasses.root} />
      {!loading && (
        <>
          {/* Todo: Update loading to come from taskEstimate query & check of estimate == 0 */}
          <NoDataItem>
            <FormattedMessage id="taskResourceEstimates.noResourceAssignments" />
          </NoDataItem>
          {/* Todo: !loading && (taskEstimate || []).map(estimate => <Row /><Divider/>) */}
          <TaskEstimateRow />
          <Divider className={dividerClasses.root} />
        </>
      )}
    </div>
  );
};

TaskResourceEstimatesContent.propTypes = {
  loading: PropTypes.bool
};

export default TaskResourceEstimatesContent;
